import { useOrderingCheckCardHandlers } from "../hooks";
import { useCheckCardContext } from "../CheckCardContext";

type Props = React.PropsWithChildren<object>;

export function CardWrapper(props: Props) {
  const {
    isDisabled = false,
    isRequiredCheck = false,
    isCardSelected,
    checkOrderingError,
    testID,
    setIsCardSelected,
    setShowModal,
    onPress,
    isReadOnly,
    showRemoveWhenSelected,
  } = useCheckCardContext();
  const { handleClick, handleKeyDown } = useOrderingCheckCardHandlers(
    isDisabled,
    isRequiredCheck,
    setIsCardSelected,
    isCardSelected,
    onPress,
    showRemoveWhenSelected,
    setShowModal
  );
  const opensDetails = showRemoveWhenSelected && isCardSelected;

  return (
    <div
      role={opensDetails ? "button" : "checkbox"}
      tabIndex={0}
      aria-checked={opensDetails ? undefined : isCardSelected}
      aria-disabled={isDisabled}
      onClick={checkOrderingError?.type === "error" ? undefined : handleClick}
      onKeyDown={handleKeyDown}
      data-testid={
        isReadOnly
          ? `${testID}-order-check-card`
          : `${testID}-order-check-card-${isCardSelected ? "selected" : "unselected"}`
      }
    >
      {props.children}
    </div>
  );
}
